import React from 'react';
import { injectIntl } from 'react-intl';

import PropTypes from 'prop-types';

import IconAddFolder from 'common/components/button/svg-icons/add-folder.svg?react';
import RibbonButton from 'common/components/button/RibbonButton';

import { SHARED_FOLDER_PATHNAME, FAVORITE_FOLDER_PATHNAME } from './pathname';

import Messages from 'i18n/messages/home';

const CreateFolder = ({
  pathname,
  disabled,
  setVisible,
  destinationFolder,
}) => {
  // Not allow make new in the shared folder
  const isFavoriteDisabled = pathname === FAVORITE_FOLDER_PATHNAME;
  const isSharedDisabled =
    pathname === SHARED_FOLDER_PATHNAME && !destinationFolder?.editable;
  const disableButton = isFavoriteDisabled || isSharedDisabled || disabled;

  const showCreateFolderModal = () => {
    setVisible(true);
  };

  return (
    <RibbonButton
      size='small'
      icon={<IconAddFolder />}
      label={Messages.newFolder}
      disabled={disableButton}
      onClick={showCreateFolderModal}
    />
  );
};

CreateFolder.propTypes = {
  pathname: PropTypes.string,
};

export default injectIntl(CreateFolder);
